import React from 'react';
import { useI18n } from '../i18n/i18nContext';

const Hero: React.FC = () => {
  const { t, language } = useI18n();
  const isLongLanguage = language === 'fi' || language === 'ru';
  const isEstonian = language === 'et';

  return (
    <div className="relative h-[400px] md:h-[500px] overflow-hidden">
      {/* Background Image */}
      <img
        src="/images/hero-bg.webp"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4 pt-16 md:pt-0">
        <div className="max-w-4xl mx-auto">
          <h1 className={`${isEstonian ? 'text-3xl md:text-5xl' : 'text-4xl md:text-6xl'} font-bold mb-8 animate-fadeIn animation-delay-0`}>
            {t.hero?.title || "Welcome to Fire & Ice"}
          </h1>
          <p className="text-lg md:text-2xl mb-8 max-w-2xl animate-fadeIn animation-delay-1">
            {t.hero?.subtitle || "Experience the ultimate wellness journey with our premium services"}
          </p>
          <div className={`mt-6 ${isLongLanguage ? 'text-base' : 'text-xl'} md:text-2xl font-semibold flex flex-col items-center`}>
            <div className="inline-grid grid-cols-2 gap-x-12 gap-y-2">
              <p className="animate-fadeIn animation-delay-2 text-right whitespace-nowrap">{t.hero?.benefit1 || "Perform Better"}</p>
              <p className="animate-fadeIn animation-delay-4 text-left whitespace-nowrap">{t.hero?.benefit3 || "Work Better"}</p>
              <p className="animate-fadeIn animation-delay-3 text-right whitespace-nowrap">{t.hero?.benefit2 || "Feel Better"}</p>
              <p className="animate-fadeIn animation-delay-5 text-left whitespace-nowrap">{t.hero?.benefit4 || "Sleep Better"}</p>
            </div>
            <p className="animate-fadeIn animation-delay-6 font-bold mt-4 whitespace-nowrap">{t.hero?.benefit5 || "Live Better"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;